module.exports = __webpack_public_path__ + "static/media/broadcast-tower.49035beb.svg";